import {useAddBanner, useDismissBanner, useFocusBanner} from '@github-ui/banner-stack'
import {useCallback, useRef} from 'react'

/**
 * Shows one dismissible critical banner at a time for a repeatable mutation.
 */
export function useDismissibleErrorBanner(title: string) {
  const addBanner = useAddBanner()
  const dismissBanner = useDismissBanner()
  const focusBanner = useFocusBanner()
  const currentBannerIdRef = useRef<string | undefined>(undefined)

  const dismissCurrentBanner = useCallback(() => {
    if (!currentBannerIdRef.current) return

    dismissBanner(currentBannerIdRef.current)
    currentBannerIdRef.current = undefined
  }, [dismissBanner])

  const showErrorBanner = useCallback(() => {
    dismissCurrentBanner()

    const bannerId = addBanner({
      title,

      variant: 'critical',
      dismissible: true,
      onDismiss: () => {
        currentBannerIdRef.current = undefined
      },
    })
    currentBannerIdRef.current = bannerId
    requestAnimationFrame(() => focusBanner(bannerId))
  }, [addBanner, dismissCurrentBanner, focusBanner, title])

  return {dismissCurrentBanner, showErrorBanner}
}
